'use strict';

const treeTokens = (theme) => ({
    treeItemPaddingLeft: theme.space.component.x.m,
    treeTextColor: theme.palette.grey600,
    treeErroredTextColor: theme.colors.danger.normal,
});

exports.treeTokens = treeTokens;
//# sourceMappingURL=tree.js.map
